
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.009 1C5.929 1 1 5.921 1 11.991c0 4.659 2.9 8.639 6.995 10.24-.1-.868-.181-2.207.036-3.157.2-.86 1.287-5.464 1.287-5.464s-.326-.66-.326-1.628c0-1.529.888-2.669 1.993-2.669.942 0 1.396.706 1.396 1.547 0 .941-.598 2.352-.916 3.664-.262 1.094.553 1.99 1.631 1.99 1.958 0 3.462-2.063 3.462-5.03 0-2.632-1.894-4.468-4.603-4.468-3.135 0-4.975 2.343-4.975 4.767 0 .94.363 1.954.816 2.506.09.108.1.208.072.316-.081.344-.272 1.095-.308 1.249-.045.199-.163.244-.371.144-1.378-.642-2.238-2.641-2.238-4.26 0-3.465 2.519-6.65 7.275-6.65 3.815 0 6.787 2.715 6.787 6.351 0 3.79-2.392 6.839-5.708 6.839-1.115 0-2.166-.579-2.52-1.266l-.688 2.614c-.244.959-.915 2.153-1.368 2.886 1.033.316 2.12.488 3.262.488C18.07 23 23 18.079 23 12.009 23.018 5.921 18.089 1 12.009 1z","fill":"#E60023","fill-rule":"nonzero"}})])
          )
        }
      }
    